const ToolTip = ({ text }) => {
  return <span className='tooltiptext'>{text}</span>
}

export default ToolTip
